const getCart = async () => {
  const response = await fetch(window.Shopify.routes.root + "cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const cart = await response.json();
  return cart;
};

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  // Remove cents if it's .00
  if (typeof value == "string") {
    value = value.replace(".00", "");
  }

  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

const genPriceHtm = (_price, discount = window.activeGlobalDiscount.discount, range = false) => {
  let price = parseFloat(_price);
  const badge_text = window.activeGlobalDiscount.badge_text || "%";
  let classess = "";
  if (!document.querySelector(".template-product")) {
    classess = "typography-desktop-14 typography-mobile-13";
  }
  if (range) {
    let price_min = parseFloat(_price.split("-")[0]) * 100;
    let price_max = parseFloat(_price.split("-")[1]) * 100;
    return `
        <lwp-price class="ff-text text-subdued">
          <span class="lwp-discounted-price ${classess}">${formatMoney(
      (price_min * (100 - discount)) / 100
    )}-${formatMoney((price_max * (100 - discount)) / 100)}</span>
          <span class="lwp-origin-price ${classess}">${formatMoney(price_min)}-${formatMoney(price_max)}</span>
          <span class="lwp-offer-percent ${classess}">${badge_text.replace("{{amount}}", discount)}</span>
        </lwp-price>
      `;
  } else {
    return `
        <lwp-price class="ff-text text-subdued">
          <span class="lwp-discounted-price ${classess}">${formatMoney((price * (100 - discount)) / 100)}</span>
          <span class="lwp-origin-price ${classess}">${formatMoney(price)}</span>
          <span class="lwp-offer-percent ${classess}">${badge_text.replace("{{amount}}", discount)}</span>
        </lwp-price>
      `;
  }
};

// Init

const isDiscountDisabled = (el) => {
  parentEl = el.closest("[global-discount-disabled]") || el.closest("[data-nosto-product]");
  // check if parentEl has attribute global-discount-disabled and is true
  if (parentEl && parentEl.hasAttribute("global-discount-disabled")) {
    return true;
  }
  return false;
};

const injectDiscountedPrice = () => {
  console.log("Discount:: Global start");

  document.querySelectorAll("[data-lwp-price]").forEach((priceEl) => {
    if (!isDiscountDisabled(priceEl)) {
      priceEl.innerHTML = genPriceHtm(priceEl.dataset.lwpPrice);
    }
  });

  document.querySelectorAll(".ns-product__price-wrap").forEach((priceEl) => {
    if (!isDiscountDisabled(priceEl)) {
      let nostoProduct = priceEl.closest("[data-nosto-product]");
      if (nostoProduct.hasAttribute("data-discount-bead-table")) {
        if (nostoProduct.hasAttribute("data-nosto-price-range")) {
          let _price = nostoProduct.dataset.nostoPriceRange;
          priceEl.innerHTML = genPriceHtm(_price, window?.activeGlobalDiscount?.discount, true);
        } else {
          let _price = parseFloat(nostoProduct.dataset.nostoPrice) * 100;
          priceEl.innerHTML = genPriceHtm(_price, window?.activeGlobalDiscount?.discount);
        }
      }
    } else {
      // let _price = parseFloat(priceEl.closest("[data-nosto-product]").dataset.nostoPrice) * 100;
      // priceEl.innerHTML = genPriceHtm(_price);
    }
  });
  document.querySelectorAll(".nosto_element price-list").forEach((priceEl) => {
    if (priceEl.closest("[global-discount-disabled]")) {
      return;
    }
    if (priceEl.querySelector("sale-price")) {
      priceEl.querySelector("sale-price .sr-only").remove();
      let priceStr = priceEl.querySelector("sale-price").innerText;
      let price = parseFloat(priceStr.slice(1, priceEl.length)) * 100;

      if (priceEl.getAttribute("data-lwp-price") && priceEl.getAttribute("data-lwp-price") != "") {
        const priceWithoutFormat = priceEl?.getAttribute("data-lwp-price")?.replace(/[^0-9-]+/g, "");
        price = parseFloat(priceWithoutFormat);
      }

      priceEl.innerHTML = genPriceHtm(price);
      priceEl.setAttribute("data-lwp-price", price);
    } else {
      let price = priceEl.getAttribute("data-lwp-price");
      if (price?.includes("$")) {
        price = price.replace(/[^0-9-]+/g, "");
      }
      priceEl.innerHTML = genPriceHtm(price);
    }
  });
};

const initGlobalDiscount = async (is_force = false) => {
  const cart = await getCart();
  let cartTotal = cart.original_total_price;
  let discount = null;
  window.globalDiscountArr.discounts.forEach((_discount) => {
    if (
      parseFloat(_discount.threshold) * 100 <= cartTotal &&
      parseFloat(_discount.threshold) >= parseFloat(discount?.threshold || 0)
    ) {
      discount = _discount;
    }
  });
  if ((discount == null || discount == window.activeGlobalDiscount) && !is_force) return;
  window.activeGlobalDiscount = discount;
  injectDiscountedPrice();
};

const initNostoElMutationObserver = () => {
  let isNostoPriceUpdated = false;
  let nostoEl = document.querySelector(".nosto_element");
  if (!nostoEl) return;
  let config = { attributes: true, childList: true, subtree: true };
  let callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        if (document.querySelector(".nosto_element .product-card")) {
          setTimeout(() => {
            if (!isNostoPriceUpdated) {
              initGlobalDiscount(true);
              isNostoPriceUpdated = true;
            }
          }, 1500);
        }
      } else if (mutation.type === "attributes") {
      }
    }
  };
  let observer = new MutationObserver(callback);
  observer.observe(nostoEl, config);
};

document.addEventListener("cart:refreshed", () => {
  setTimeout(() => {
    // initGlobalDiscount();
    console.log("Discount:: Global cart refreshed");
    injectDiscountedPrice();
  }, 1000);
});

document.addEventListener("nostoProductAdded", () => {
  initGlobalDiscount(true);
});

document.addEventListener("DOMContentLoaded", () => {
  let globalDiscountJson = document.querySelector("#GlobalDiscountJson").innerHTML;
  window.globalDiscountArr = JSON.parse(globalDiscountJson);
  window.activeGlobalDiscount = null;

  initGlobalDiscount();
  initNostoElMutationObserver();
});